export function getRelativeDate(date: Date) {
    const rtf = new Intl.RelativeTimeFormat(undefined, { style: "long" });
    const now = new Date();

    const diffMs = date.getTime() - now.getTime(); // negative = past, positive = future
    const absMs = Math.abs(diffMs);

    const SECOND = 1000;
    const MINUTE = 60 * SECOND;
    const HOUR = 60 * MINUTE;
    const DAY = 24 * HOUR;

    const threshold = 6 * DAY;

    if (absMs > threshold) {
        return new Intl.DateTimeFormat().format(date);
    }

    if (absMs < MINUTE) {
        return "Now";
    } else if (absMs < HOUR) {
        return rtf.format(Math.round(diffMs / MINUTE), "minute");
    } else if (absMs < DAY) {
        return rtf.format(Math.round(diffMs / HOUR), "hour");
    } else {
        return rtf.format(Math.round(diffMs / DAY), "day");
    }
}

export function getAppGuid(): string | null{
  let path = window.location.pathname;

  var split = path.split("/");

  if (split.length < 3) {
    return null;
  }

  const appGuid = split[2].split("?")[0];

  if (appGuid !== null && appGuid !== "") {
    return appGuid;
  }

  return "";
}

export function getContentIdFromContentUrl(contentUrl: string): string {
  let contentId: string = '';
  if (
    contentUrl.includes("?") &&
    contentUrl.split("/Index/")[1]?.split("?")[0]
  ) {
    contentId = contentUrl.split("/Index/")[1]?.split("?")[0];
  } else if (contentUrl.split("/Index/")[1]?.split("#")[0]) {
    contentId = contentUrl.split("/Index/")[1]?.split("#")[0];
  }
  return contentId;
}

export function toSentenceCase(string: string) {
  return string
    .split(" ")
    .map((w) => w[0].toUpperCase() + w.substr(1).toLowerCase())
    .join(" ");
}
